import { useRef } from 'react'
import styles from './TopFirstView.module.scss'
import animationStyles from 'components/commons/Animation/Animation.module.scss'
import useElementVisible from 'components/commons/Animation/useElementVisible'
import Button from 'components/common/Button/Button'
import AiddBanner from './AiddBanner'

const NOTICE_HREF = '/pressrelease/5170/'

const TopFirstView: React.FC = () => {
  const noticeRef = useRef<HTMLDivElement>(null)
  const isNoticeVisible = useElementVisible(noticeRef, 0.1)
  const bannerRef = useRef<HTMLDivElement>(null)
  const isBannerVisible = useElementVisible(bannerRef, 0.1)

  return (
    <section className={styles.topFV}>
      <div
        className={`${styles.topFV__notice} ${animationStyles.fade} ${isNoticeVisible ? animationStyles.fadeOn : ''}`}
        ref={noticeRef}
      >
        <a href={NOTICE_HREF} className={styles.topFV__notice__link} aria-label="社名変更のお知らせを詳しく見る" />
        <div className={styles.topFV__notice__inner}>
          <div className={styles.topFV__notice__content}>
            <div className={styles.topFV__notice__title}>
              <span className={styles.topFV__notice__dot} aria-hidden="true" />
              <span>社名変更のお知らせ</span>
            </div>
            <div className={styles.topFV__notice__detail}>
              <p className={styles.topFV__notice__text}>i3DESIGNからAitriaに変更しました。</p>
              <p className={styles.topFV__notice__date}>（2026/11/04）</p>
            </div>
          </div>
          <div className={styles.topFV__notice__action}>
            <div className={styles.topFV__notice__button}>
              <Button text="詳しく見る" href={NOTICE_HREF} />
            </div>
            <span className={styles.topFV__notice__arrow} aria-hidden="true">
              <img src="/img/common/direction_red.svg" alt="" width={20} height={20} />
            </span>
          </div>
        </div>
      </div>

      <div className={styles.topFV__body}>
        <div
          className={`${styles.topFV__banner} ${animationStyles.fade} ${isBannerVisible ? animationStyles.fadeOn : ''}`}
          ref={bannerRef}
        >
          <AiddBanner />
        </div>
        <h1 className={styles.topFV__title}>
          Design × AI × Engineering で、
          <br className={styles.tab} />
          日本のITを再起動する。
          <br />
          AitriaはAI駆動のデジタルエンジニアリング企業です。
        </h1>
        <p className={styles.topFV__text}>
          AIエージェント、モダンスタック、CI/CD、DevOps、UX/UIをフル活用した開発スタイルで、顧客のモダナイゼーションとAIシフトを実装します。
        </p>
      </div>
    </section>
  )
}

export default TopFirstView
